import { render, staticRenderFns } from "./c_product.vue?vue&type=template&id=454693ec&scoped=true"
import script from "./c_product.vue?vue&type=script&lang=js"
export * from "./c_product.vue?vue&type=script&lang=js"
import style0 from "./c_product.vue?vue&type=style&index=0&id=454693ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454693ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454693ec')) {
      api.createRecord('454693ec', component.options)
    } else {
      api.reload('454693ec', component.options)
    }
    module.hot.accept("./c_product.vue?vue&type=template&id=454693ec&scoped=true", function () {
      api.rerender('454693ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_product.vue"
export default component.exports